<script>
import _debounce from "lodash/debounce";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  components: {
    CommonTableComponent
  },
  props: ['contract', 'disabled', 'work_order_type'],
  mixins: [pagination, tableSearch],
  data() {
    return {
      isLoading: false,
      transportContracts: [],
      dataSelected: {},
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const url = apiEndpoints.projects_sales_transport_contracts(this.$route.params.id);
      const sendApiProject = await this.$http.get(url,{workOrderType:this.work_order_type});
      const {status, data} = sendApiProject;

      if (status && data.result) {
        this.transportContracts = data.result;
        this.dataSelected = this.contract ?? {}
      }
      this.isLoading = false;
    },
    updateValue: function () {
      this.$emit("dataSelected", this.dataSelected);
      this.$bvModal.hide("select-transport-contracts");
    },
    onClickRow(item) {
      this.dataSelected = item;
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "CA管理番号",
          value: "transport_contract_cd",
          sortable: true
        },
        {
          text: "契約名",
          value: "transport_contract_name",
          sortable: true
        }
      ];
    },
    disableButtonContractSelect() {
      return this.work_order_type == this.$constant.work_order_type.work || this.work_order_type == this.$constant.work_order_type.others
    },
  },
  watch: {
    contract: {
      handler: function(val) {
        if (!val) return;
        this.dataSelected = val ?? {}
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <button
      v-b-modal.select-transport-contracts
      class="btn btn-primary waves-effect waves-light"
      :disabled="disableButtonContractSelect || disabled"
    >
      <i class='far fa-list-alt'></i> 収集運搬契約を選択する
    </button>
    <!-- modal area -->
    <b-modal
      size="lg"
      id="select-transport-contracts"
      centered
      title-class="font-18"
      hide-footer
      title="収集運搬契約一覧"
      scrollable
      @show="getData"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
            <tr>
              <th>選択</th>
              <th
                v-for="(item, index) in headers"
                :key="index"
                :class="getHeaderClass(item)"
              >
                <span>
                    {{ item.text }}
                  </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="(item, index) in transportContracts"
              :key="index"
              @click="onClickRow(item)"
              class="cursor-pointer"
            >
              <td class="text-center">
                <label>
                  <b-form-radio
                    class="cursor-pointer"
                    v-model="dataSelected"
                    :value="item"
                  ></b-form-radio>
                </label>
              </td>
              <td>
                {{ item.transport_contract_cd }}
              </td>
              <td>
                {{ item.transport_contract_name }}
              </td>
            </tr>
            <tr v-if="!transportContracts.length && !isLoading">
              <td :colspan="headers.length" class="text-center">
                データなし。
              </td>
            </tr>
            </tbody>
          </CommonTableComponent>
          <div class="d-flex justify-content-end mt-2">
            <button
              @click="updateValue"
              class="btn btn-primary w-md waves-effect waves-light"
            >
              <i class='fas fa-check'></i> 確定
            </button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
